"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var AppMargins_1 = require("../../../app/components/AppMargins");
var DirectoryTable_1 = __importDefault(require("./DirectoryTable"));
var appMargins_1 = __importDefault(require("../../../app/components/AppMargins/appMargins"));
var MobilePanel_1 = __importDefault(require("./MobilePanel"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b;
    return core_1.createStyles({
        resultsHeaderText: (_a = {
                marginTop: theme.spacing(7.25)
            },
            _a[theme.breakpoints.up('md')] = {
                marginTop: theme.spacing(11),
            },
            _a),
        tableWrapper: (_b = {
                width: '100%',
                margin: '0 auto',
                minHeight: theme.spacing(40)
            },
            _b[theme.breakpoints.up(1440)] = {
                width: theme.spacing(180),
            },
            _b),
        mobilePanel: {
            padding: theme.spacing(1.5),
        },
    });
});
/**
 * @component Holds the search results table and headers, as well as the mobile drawer.
 */
var DirectoryResults = function (_a) {
    var searchResults = _a.searchResults, pageCount = _a.pageCount, rowsPerPage = _a.rowsPerPage, resultsCount = _a.resultsCount, currentPage = _a.currentPage, changePageHandler = _a.changePageHandler, changeRowsPerPageHandler = _a.changeRowsPerPageHandler, query = _a.query, disablePagination = _a.disablePagination, rankOffset = _a.rankOffset;
    var appMargins = appMargins_1.default();
    var classes = useStyles({ appMargins: appMargins });
    var theme = core_1.useTheme();
    var isMobileView = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    var _b = __read(react_1.useState(false), 2), isMobilePanelOpen = _b[0], setIsMobilePanelOpen = _b[1];
    var _c = __read(react_1.useState(), 2), urlInfo = _c[0], setUrlInfo = _c[1];
    return (react_1.default.createElement("div", { className: classes.tableWrapper },
        react_1.default.createElement(AppMargins_1.ApplyAppMargins, null,
            react_1.default.createElement(core_1.Typography, { variant: isMobileView ? 'h5' : 'h3', className: classes.resultsHeaderText },
                !!resultsCount &&
                    "Showing " + resultsCount + " link" + (resultsCount > 1 ? 's' : '') + " for \u201C" + query + "\u201D",
                !resultsCount && "No links found for \u201C" + query + "\u201D")),
        !!resultsCount && (react_1.default.createElement(DirectoryTable_1.default, { searchResults: searchResults, pageCount: pageCount, rowsPerPage: rowsPerPage, currentPage: currentPage, changePageHandler: changePageHandler, changeRowsPerPageHandler: changeRowsPerPageHandler, resultsCount: resultsCount, setUrlInfo: setUrlInfo, setOpen: setIsMobilePanelOpen, disablePagination: disablePagination, rankOffset: rankOffset })),
        react_1.default.createElement(MobilePanel_1.default, { isOpen: isMobilePanelOpen, setOpen: setIsMobilePanelOpen, url: urlInfo })));
};
exports.default = DirectoryResults;
